<template>
  <v-dialog
    :value="showHelpDialog"
    v-if="showHelpDialog"
    persistent
    scrollable>
    <v-card>
      <dialog-header text="Knowledge Center" @closeModal="closeHelpDialog" />
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="9">
              <h2 :class="colorClass">Video Library</h2>
              <help-center-video            
                v-for="(obj, index) in videoLibrary"
                :key="index"
                :id="obj.Id"
                :video="obj.VideoFileName"
                :thumbnail="obj.ThumbnailFileName"
                :title="obj.Title"
                :description="obj.Description"/>
            </v-col>
            <v-col cols="3" class="pt-5">
              <p>
                <span>Practice: {{ practice }}</span>
              </p>
              <p>
                <span>AXIS Version: {{axis5Version}}</span>
              </p>
              <h2 :class="colorClass">User Manual</h2>
              <p style="cursor: pointer; font-weight: 600;"  @click="launchHelp">View the AXIS User Manual</p>
              <div v-if="showExportToAxis">
                <h2 :class="colorClass">Exporting to AXIS</h2>
                <p style="cursor: pointer; font-weight: 600;" @click="launchExport">Review instructions for exporting images from your practice's imaging devices to AXIS</p>
              </div>
              <h2 :class="colorClass">What's New?</h2>
              <p style="cursor: pointer; font-weight: 600;"  @click="launchNew">Review features introduced with the latest release of AXIS</p>
              <div v-if="showBestPractices" >
                <h2 :class="colorClass">Best Practices and Tips</h2>
                <p>Click below to see some of the tips provided by our users how they get the most out of AXIS:</p>
                <best-practices-entry
                  style="cursor: pointer; font-weight: 600; width: 100%;"
                  v-for="(obj, index)  in bestPracticesEntries"
                  :key="index"
                  :id="obj.Id"
                  :filename="obj.FileName"
                  :description="obj.Description"/>
              </div>
              <h2 :class="colorClass">Got More Questions?</h2>
              <p>{{ questionsText }}</p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import dialogHeader from "../dialogs/DialogHeader";
import { mapGetters, mapState, mapMutations } from "vuex";
import { openPopup } from "../../helpers/popup";
import helpCenterVideo from "../misc/HelpCenterVideo";
import bestPracticesEntry from "../misc/BestPracticesEntry.vue";

export default {
  name: "helpDialog",
  components: { dialogHeader, helpCenterVideo, bestPracticesEntry },
  computed: {
    ...mapState(["showHelpDialog"]),
    ...mapGetters(["axis5Version", "helpPdf", "onlineHelp", "defaultColorTheme", "axisTitle", "knowledgeCenterSettings", "videoLibrary", "bestPracticesEntries"]),
    practice() {
      return this.axisTitle;
    },
    axis5Color() {
      if (this.defaultColorTheme == "white")
        return "color: black;";
      return "color: yellow"
    },
    showExportToAxis() {
      return this.knowledgeCenterSettings.showExportToAxis;
    },
    questionsText() {
      return this.knowledgeCenterSettings.questionsText;
    },
    showBestPractices() {
      return this.knowledgeCenterSettings.showBestPractices && this.bestPracticesEntries.length > 0;
    }
  },
  methods: {
    ...mapMutations(["closeHelpDialog"]),
    launchHelp() {
      this.$store.dispatch("launchPDF", "helpPdf");
    },
    launchMailto(){
      let url = "mailto:axis@escalonmed.com";
      openPopup(url);
    },
    launchExport() {
      this.$store.dispatch("launchPDF", "exportToAxis");
    },
    launchNew() {
    this.$store.dispatch("launchPDF", "whatIsNew");
    },
  }
};
</script>

<style lang="scss">
.help-dialog {
  max-width: 600px;

  .axis-logo {
    max-width: 100%;
  }

  .mailto-link{
    text-decoration: underline;
    cursor:pointer;
    color: #2196f3;
  }
}
</style>